import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routers from "./routes/Routers";
import { ToastProvider } from "react-toast-notifications";
import { useSelector } from "react-redux";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import ErrorBoundary from "./pages/ErrorBoundary/ErrorBoundary";

function App() {
  // const paypalClientKey = process.env.REACT_APP_PAYPAL_CLIENT_KEY;
  const cartProduct = useSelector((state) => state.cart);

  const [paypalOptions, setPaypalOptions] = useState({
    "client-id": 'AU_re55kpjTpzSllCYwAOHP3YKNx5WjmQnaXo3i-oTGtwOUAHFpW2zOa2WuQWVDweh-0j6yqXyzUIQ_u',
    currency: "USD",
    vault: true,
    locale: "en_US",
    "data-sdk-integration-source": "integrationbuilder_sc",
    intent: "authorize", // Default value
  });

  useEffect(() => {
    const newIntent = cartProduct.type === "subscription" ? "subscription" : "authorize";
    setPaypalOptions((prevOptions) => ({
      ...prevOptions,
      intent: newIntent,
    }));
  }, [cartProduct.type]);

  // Unmount PayPalScriptProvider if intent changes
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [paypalOptions.intent]);

  return (
    <PayPalScriptProvider key={key} options={paypalOptions}>
      <ToastProvider>
        <BrowserRouter>
        <ErrorBoundary>
          <Routers />
          </ErrorBoundary>
        </BrowserRouter>
      </ToastProvider>
    </PayPalScriptProvider>
  );
}

export default App;
